type DescriptionListCodeBlockItemProps = {
  label: string;
  value?: string;
};

const DescriptionListCodeBlockItem = ({ label, value }: DescriptionListCodeBlockItemProps) => {
  return (
    <div className="py-5 grid grid-cols-3 gap-4">
      <dt className="text-sm text-gray-500">{label}</dt>
      <dd className="mt-1 flex col-span-2">
        {value ? (
          <span className="rounded px-2 py-1.5 my-1 text-xs border border-gray-300 bg-gray-50 font-mono break-all whitespace-pre-wrap text-gray-500 shadow-sm">
            {value}
          </span>
        ) : (
          <span className="text-gray-300 italic">undefined</span>
        )}
      </dd>
    </div>
  );
};

export default DescriptionListCodeBlockItem;
